import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { QueovalItem, QueovalParam, BreadcrumbModel, BObjectModel, BlockTree, RendezVousData, EventsModel, DataMode, BreadDik } from '../../models';
import { HttpService, CoreService } from '../../services';
import { DialogService } from '../../dialog';
import { ToastService } from '../../toast';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { AgendaQueovalService } from '../agenda.queoval.services';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-rendez-vous',
  templateUrl: './rendez-vous.component.html',
  styleUrls: ['./rendez-vous.component.css']
})

export class RendezVousComponent implements OnInit, OnDestroy {

  // id de la personne morale sélectionnée
  public idClientSelect: string;

  // Sauvegarde général (pas seulement le BO)
  public globalSave: boolean = false;

  // Liste des contacts de la personne morale sélectionnée
  // public listContacts: Apprenant[];

  // Liste des dossiers / affaires de la personne morale sélectionnée
  // public listDossiers: Affaire[];

  // Données du rendez-vous
  public dataRdv: RendezVousData;
  // Model "Complet"
  public model: EventsModel;

  // dataMode (si on est en création ou en modification)
  public eventMode: DataMode;

  // relationData
  public relationData: QueovalItem;

  private sub: Subscription;

  private openZoom: boolean = false;
  public zoom: boolean = false;
  /**
   * Bouton de fermeture de la modale de suppression
   */
  @ViewChild('closeDelete', { static: false }) closeDelete: ElementRef;

  constructor(
    private dialogservice: DialogService,
    private toastservice: ToastService,
    private indParam: CoreService,
    private httpService: HttpService,
    private agenda: AgendaQueovalService,
  ) { }

  @Input('param') param: QueovalParam;
  @Output() sendBreadcrump: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();
  @Output() sendEvent: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();

  ngOnInit(): void {
    this.idClientSelect = '';
    this.globalSave = false;
    this.dataRdv = new RendezVousData;
    this.dialogservice.showSplash(true);
    this.param.model.ShowRemoveButton = false;
    this.param.model.ShowSaveButton = false;

    const code: BreadDik[] = this.param.params.filter((element: BreadDik) => element.key === 'code');

    if (code && code.length > 0) {
      this.sub  = this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GETINIT/${this.param.model.IdDonneeFils}|${code[0].value}|${this.param.model.IdRelation}|${this.agenda.UserAgendaID}`).subscribe((data: EventsModel) => {
        if (!data.HasError) {
          this.dialogservice.showSplash(false);
          if (data.DataRendezvous) {
            this.model = data;
            this.dataRdv = data.DataRendezvous;
            this.eventMode = data.EventMode;
            this.relationData = data.RelationData;
            // Si c'est en création initialisation du client sinon récupération de l'existant
            if (this.eventMode === 1) {
              this.dataRdv.RdvSelectedClient = new QueovalItem();
            } else {
              // Récupération du client sélectionné pour chercher les listes de ses contacts et affaires
              if (this.dataRdv.RdvSelectedClient && this.dataRdv.RdvSelectedClient.Value !== '' && this.dataRdv.RdvSelectedClient.Value !== undefined && this.dataRdv.RdvSelectedClient.Value !== null) {
                this.getSelectedElement(this.dataRdv.RdvSelectedClient);
              } else {
                this.dataRdv.RdvSelectedClient = new QueovalItem();
              }
            }
          }
          this.AfficheUser();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  public pageLoaded(): void {
    setTimeout(() => { this.zoom = document.getElementById('BtnZoom') ? true : false; }, 0);
  }

  public SaveRdv(): void {
    this.globalSave = false;
    setTimeout(() => {
      this.globalSave = true;
    }, 0);
  }

  public SaveRdvAndOpenZoom(): void {
    this.openZoom = true;
    this.globalSave = false;
    setTimeout(() => {
      this.globalSave = true;
    }, 0);
  }

  public afficheZoneParticipant(list: QueovalItem[]): boolean {
    for (const item of list) {
      if (item.Selected) {
        return true;
      }
    } if (this.dataRdv.RdvSelectedAffaire && this.dataRdv.RdvSelectedAffaire.Selected) {
      return true;
    }
    return false;
  }
  public afficheZoneParticipantBT(list: BlockTree[]): boolean {
    for (const groupe of list) {
      for (const item of groupe.Children)
      if (item.IsChecked) {
        return true;
      }
    }
    return false;
  }

  // Link du stage sur la reservation apres la sauvgarde de la reservation
  public getIdBoRdv(BOEvent: BObjectModel): void {
    if (BOEvent && BOEvent.Error !== 'NOTVALID') {
      if (this.globalSave) {
        this.globalSave = false;
        this.dialogservice.showSplash(true);
        // Récupération des contacts sélectionnés
        this.dataRdv.RdvSelectedContact = new Array<QueovalItem>();
        if (this.dataRdv.ListContacts) {
          this.dataRdv.ListContacts.forEach((contact: QueovalItem) => {
            if (contact.Selected) {
              this.dataRdv.RdvSelectedContact.push(contact);
            }
          });
        }

        // Récupération de l'affaire sélectionnée
        if (this.dataRdv.ListAffaires) {
          const testUndefined: QueovalItem | undefined = _.find(this.dataRdv.ListAffaires, { 'Selected': true });
          //if (testUndefined !== undefined) {
          this.dataRdv.RdvSelectedAffaire = testUndefined !== undefined ? testUndefined : new QueovalItem();
          //}
        } else {
          this.dataRdv.RdvSelectedAffaire = new QueovalItem();
        }
        const model: EventsModel = this.model;
        model.Mode = 'SAVERDV';
        model.idUserEvent = this.agenda.UserAgendaID;
        model.DataRendezvous = this.dataRdv;
        model.RelationData = this.relationData;
        model.EventId = BOEvent.IdDonneeFils;
        this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe((data: EventsModel) => {
          if (!data.HasError) {
            this.model = data;
            // Message succes + redirection
            if (this.openZoom) {
              const p: Array<BreadDik> = new Array<BreadDik>();
              p.push(new BreadDik('params', ''));
              const param: { params: Array<BreadDik>, model: BObjectModel } = { params: p, model: BOEvent };
              const breadCrumbItem: BreadcrumbModel = new BreadcrumbModel('', 'zoom', param, 'Salle Virtuelle', true);
              this.sendBreadcrump.emit(breadCrumbItem);

            } else {
              this.sendEvent.emit(new BreadcrumbModel('back', '', null, '', false));
            }
          }
          this.dialogservice.showSplash(false);
        });
      }
    } else {
      this.globalSave = false;
      this.openZoom = false;
      this.dialogservice.showSplash(false);
    }
  }

  // Confirmation de la suppression du rendez-vous
  public confirmDelete(): void {
    const model: EventsModel = this.model;
    this.dialogservice.showSplash(true);
    model.Mode = 'DELETERDV';
    this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        this.model = data;
        this.dialogservice.showSplash(false);
        if (data.Alert.length > 0) {
          this.toastservice.showWarningToast(data.Alert);
        } else {
          // Message succes + redirection
          this.closeModalDelete();
          this.sendEvent.emit(new BreadcrumbModel('back', '', null, '', false));
          this.toastservice.showSuccessToast('Rendez-vous supprimé');
        }
      }
    });
  }

  // Fermeture de la modale de suppression
  public closeModalDelete(): void {
    this.closeDelete.nativeElement.click();
  }

  // récupère la liste des apprenants à partir de l'ident d'un client "sélectionné"
  public getSelectedElement(element: QueovalItem): void {
    if (!element.Value) {
      this.toastservice.showAlertToast(`Erreur de récupération du client sélectionné`);
    } else {
      if (element.Value === 'DELETE') {
        // Suppression des listes
        this.dataRdv.ListContacts = new Array<QueovalItem>();
        this.dataRdv.ListAffaires = new Array<QueovalItem>();
        this.dataRdv.RdvSelectedClient = new QueovalItem();
      } else {
        this.dataRdv.RdvSelectedClient = element;
        this.dataRdv.RdvSelectedClient.Text = this.transform(this.dataRdv.RdvSelectedClient.Text, '|', 0);
        const isAffaire: string = this.dataRdv.IsModeAffaire ? '1' : '0';
        this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GetListsFromClient/${element.Value}|${isAffaire}`).subscribe((data: EventsModel) => {
          if (!data.HasError) {
            this.dialogservice.showSplash(false);
            this.dataRdv.ListContacts = data.DataRendezvous.ListContacts;
            this.dataRdv.ListAffaires = data.DataRendezvous.ListAffaires;
            // S'il y a déjà des contacts / affares sélectionnées on modifie la liste
            if (this.dataRdv.ListContacts) {
              this.dataRdv.ListContacts.forEach((contact: QueovalItem) => {
                this.dataRdv.RdvSelectedContact.forEach((selcontact: QueovalItem) => {
                  if (contact.Value === selcontact.Value) {
                    contact.Selected = true;
                  }
                });
              });
            }

            //push RdvSelectedAffaire si dossier cloturé et absent dans la ListAffaires
            if (this.dataRdv.RdvSelectedAffaire.Value && !this.dataRdv.ListAffaires.find((i: QueovalItem) => i.Value === this.dataRdv.RdvSelectedAffaire.Value)) {
              this.dataRdv.ListAffaires.push(this.dataRdv.RdvSelectedAffaire);
            }
            if (this.dataRdv.ListAffaires && this.dataRdv.RdvSelectedAffaire) {
              this.dataRdv.ListAffaires.forEach((affaire: QueovalItem) => {
                if (affaire.Value === this.dataRdv.RdvSelectedAffaire.Value) {
                  affaire.Selected = true;
                }
              });
            }

          }
        });
      }

    }
  }

  // Ajout / Retrait d'un groupe de collaborateur
  public addGrpCollabo(groupe: BlockTree): void {
    // e.stopPropagation();
    groupe.IsChecked = !groupe.IsChecked;
    // Même chose pour tous les utilisateurs du groupe ( en cascade)
    groupe.Children.forEach((user: BlockTree) => {
      user.IsChecked = groupe.IsChecked;
    });
    groupe.Children.forEach((user: BlockTree) => {
      this.propItems(this.model.DataRendezvous.ListParticipants.Children, user.Value, user.IsChecked);
    });
    this.AfficheUser();
  }

  // Ajout / Retrait d'un collaborateur
  public addCollabo(groupe: BlockTree, collabo: BlockTree): void {
    // e.stopPropagation();
    collabo.IsChecked = !collabo.IsChecked;
    // Si on décoche 1 user alors le groupe doit être décoché
    if (!collabo.IsChecked) {
      groupe.IsChecked = false;
    }
    this.propItems(this.model.DataRendezvous.ListParticipants.Children, collabo.Value, collabo.IsChecked);

    this.AfficheUser();
  }

  private AfficheUser(): void {
    //liste des participants déjà visibles
    const ListParticipants: Array<string> = new Array<string>();

    //pour chaque occurence de l'utilisateur passé en paramètre dans chaque groupe
    this.dataRdv.ListParticipants.Children.forEach((groupe: BlockTree) => {
      groupe.Children.forEach((user: BlockTree) => {
        //on le cache si il n'est pas check
        if (!user.IsChecked) {
          user.IsVisible = false;
        } else {
          //on le rend visible si il n'est pas déjà dans la liste des participants visibles
          if (!ListParticipants.includes(user.Value)) {
            ListParticipants.push(user.Value);
            user.IsVisible = true;
          } else {
            user.IsVisible = false;
          }
        }
      });
    });
  }

  // S'il y a au moins 1 collaborateur coché dans le groupe
  public oneUserCheckInGrp(groupe: BlockTree): boolean {
    let result: boolean = false;
    groupe.Children.forEach((user: BlockTree) => {
      if (user.IsChecked) {
        result = true;
      }
    });
    return result;
  }

  public allUserCheckInGrp(groupe: BlockTree): boolean {
    const ckl: Array<BlockTree> = groupe.Children.filter((c: BlockTree) => c.IsChecked);
    return ckl && ckl.length === groupe.Children.length;
  }

  // Ajout / Retrait d'un élément (contact, affaire...)
  public addItem(item: QueovalItem): void {
    // e.stopPropagation();
    item.Selected = !item.Selected;
  }
  public addAffaire(el: QueovalItem): void {
    const item: QueovalItem | undefined = this.dataRdv.ListAffaires.find((i: QueovalItem) => i.Value === el.Value);
    if (item) {
      item.Selected = !item.Selected;
      this.dataRdv.ListAffaires.forEach((affaire: QueovalItem) => {
        if (affaire.Value !== item.Value) {
          affaire.Selected = false;
        }
      });

      if (item.Selected) {
        this.dataRdv.RdvSelectedAffaire = item;
      } else {
        this.dataRdv.RdvSelectedAffaire = new QueovalItem();
      }
    }
  }

  // Teste si au moins 1 contact est sélectionné
  public oneContactSelected(): boolean {
    let result: boolean = false;
    this.dataRdv.ListContacts.forEach((user: QueovalItem) => {
      if (user.Selected) {
        result = true;
      }
    });
    return result;
  }

  // Copy du pipe showValueSeparat pour n'afficher que le nom du client dans propriété Text
  private transform(value: string, separator: string, index: number): string {
    if (!value) {
      return value;
    } else {
      if (!value.includes(separator)) {
        return value;
      } else {
        return value.split(separator)[index];
      }
    }
  }

  private propItems(children: BlockTree[], itemValue: string, itemCheck: boolean): void {
    children.forEach((e: BlockTree) => {
      const r: BlockTree[] = e.Children.filter((x: BlockTree) => x.Value === itemValue);
      if (r) {
        r.forEach((y: BlockTree) => y.IsChecked = itemCheck);
      }
    });
  }
}
